export const env = {
    API_ENDPOINT: process.env.REACT_APP_API_URL || "",
};
